import { useQuery } from '@tanstack/react-query';
import { lacTenantService } from '../../../services/LacTenantService';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacTenantQuery(tenantName: string | undefined) {
  return useQuery({
    queryKey: lacQueryKeys.tenant(tenantName ?? ''),
    enabled: Boolean(tenantName),
    queryFn: () => {
      if (!tenantName) {
        throw new Error('Missing tenant name');
      }
      return lacTenantService.getTenant(tenantName);
    },
  });
}
